import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import store from './store/index'

Vue.use(VeeValidate);
Vue.use(Vuex);
Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');